import React, { useState, useEffect, useRef } from 'react';
import { useConversation } from '@11labs/react';
import logo from '../../imgs/empl.jpg';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import './HumangestStyle.css'
import { S3Client, PutObjectCommand } from '@aws-sdk/client-s3';

const HumangestPage = () => {

  const searchParams = new URLSearchParams(window.location.search);
  const email = searchParams.get('email') || "";

  const [microphoneAccessGranted, setMicrophoneAccessGranted] = useState(false);
  const [volume, setVolume] = useState(0.5);
  const [agentInfo, setAgentInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [privacyAccepted, setPrivacyAccepted] = useState(false);
  const [userData, setUserData] = useState(null);
  const [conversationId, setConversationId] = useState(null);
  const [transcription, setTranscription] = useState([]);
  const [conversationDone, setConversationDone] = useState(false);
  const transcriptionRef = useRef([]);
  const conversationIdRef = useRef(null);

  const {
    startSession,
    endSession,
    setVolume: setConversationVolume,
    status,
    isSpeaking,
  } = useConversation({
    onConnect: (session) => {
        setConversationId(session.conversationId);
        conversationIdRef.current = session.conversationId; // Salva in ref
        console.log("Connessione avvenuta con sessione:", session.conversationId);
    },
    onDisconnect: () => {
      console.log('Connessione terminata');
      localStorage.setItem('done', "true");
      setConversationDone(true);
      handleEndConversationAuto();
    },
    onMessage: (message) => {
      const newEntry = {
        sender: message.source,
        content: message.message,
        timestamp: new Date().toISOString()
      };
      
      // Aggiorna sia lo stato che il ref
      transcriptionRef.current = [...transcriptionRef.current, newEntry];
      setTranscription(prev => [...prev, newEntry]);
      
      console.log('Trascrizione aggiornata:', transcriptionRef.current);
      },
    onError: (error) => console.error('Errore:', error),
  });

  console.log("ConversationId:", conversationIdRef.current);
  console.log("Transcription:", transcriptionRef.current);
  // Riferimento per gestire lo stato della conversazione (per il popup video)
  const conversationStartedRef = useRef(false);

  let videoSrc = 'https://www.deepagent.app/wp-content/uploads/2025/03/Video-WhatsApp-2025-03-14-ore-12.19.16_6ab6c1cc.mp4'; // URL di default

  // Richiede l'accesso al microfono
  const requestMicrophoneAccess = async () => {
    try {
      await navigator.mediaDevices.getUserMedia({ audio: true });
      setMicrophoneAccessGranted(true);
    } catch (error) {
      console.error('Accesso al microfono negato:', error);
      setMicrophoneAccessGranted(false);
    }
  };

  useEffect(() => {
    const checkMicrophonePermission = async () => {
      try {
        const permissionStatus = await navigator.permissions.query({ name: 'microphone' });
        setMicrophoneAccessGranted(permissionStatus.state === 'granted');
        permissionStatus.onchange = () => {
          setMicrophoneAccessGranted(permissionStatus.state === 'granted');
        };
      } catch (error) {
        console.error('Errore nel controllo del permesso del microfono:', error);
      }
    };

    if (localStorage.getItem('done') === "true") {
      setConversationDone(true);
    }

    checkMicrophonePermission();
    
  }, []);

  async function downloadElevenLabsAudio(conversationId, apiKey) {
    try {
      const response = await axios({
        method: 'GET',
        url: `https://api.elevenlabs.io/v1/convai/conversations/${conversationId}/audio`,
        headers: {
          'Accept': 'audio/mpeg',
          'xi-api-key': apiKey
        },
        responseType: 'arraybuffer'
      });
  
      console.log('Audio scaricato con successo');
      return response.data;
    } catch (error) {
      console.error('Errore durante il download dell\'audio:', error.message);
      throw error;
    }
  }
  async function downloadAndUploadAudio(conversationId) {
    try {
      // 1. Scarica l'audio da ElevenLabs
      const audioData = await downloadElevenLabsAudio(conversationId, process.env.REACT_APP_ELEVENLABS_API_KEY);
      
      if (!audioData) {
        throw new Error("Audio non disponibile");
      }
      
      // 2. Configura il client S3
      const s3Client = new S3Client({
        region: process.env.REACT_APP_AWS_REGION || 'eu-west-1',
        credentials: {
          accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
          secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
        }
      });
      
      // 3. Prepara il nome del file (usa email e timestamp per renderlo unico)
      const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
      const fileName = `${email ? email.replace('@', '_at_') : 'unknown'}_${timestamp}.mp3`;
      
      // 4. Carica il file su S3
      const uploadParams = {
        Bucket: process.env.REACT_APP_S3_BUCKET_NAME,
        Key: `conversations/${fileName}`,
        Body: audioData,
        ContentType: 'audio/mpeg'
      };
      
      const uploadCommand = new PutObjectCommand(uploadParams);
      const uploadResult = await s3Client.send(uploadCommand);
      
      // 5. Genera l'URL pubblico del file
      const s3Url = `https://${uploadParams.Bucket}.s3.${process.env.REACT_APP_AWS_REGION || 'eu-west-1'}.amazonaws.com/${uploadParams.Key}`;
      
      console.log("Audio caricato con successo su S3:", s3Url);
            
      return s3Url;
    } catch (error) {
      console.error("Errore nel processo di download e upload dell'audio:", error);
      throw error;
    }
  }

  // Recupera i dati dell'utente da SheetBest
  useEffect(() => {
    const fetchUserData = async () => {
      if (!email) return;
      
      try {
        const response = await axios.get(`https://api.sheetbest.com/sheets/ea03667d-aba0-4d57-b4a3-b325c66c5b3a`);

        if (response.data && Array.isArray(response.data)) {
          // Cerca la riga con l'email corrispondente
          const userRow = response.data.find(row => row.Email && row.Email.toLowerCase() === email.toLowerCase());

          if (userRow) {
            console.log('Dati utente trovati:', userRow);
            setUserData(userRow);
          } else {
            console.log('Nessun dato trovato per l\'email:', email);
          }
        }
      } catch (error) {
        console.error('Errore nel recupero dei dati da SheetBest:', error);
      }
    };

      //downloadAndUploadAudio("MXYc30Uqw0X9gTg7skC9");

    fetchUserData();
  }, [email]); // Dipendenza dall'email per rieseguire quando cambia

  // Avvia la conversazione e imposta il riferimento a true
  const handleStartConversation = async () => {
    try {
      await requestMicrophoneAccess();

      const dynamicVars = {
        user_name: userData?.Nome || "Nessuna info",
        user_lastname: userData?.Cognome || "Nessuna info",
        user_email: email || "Nessuna info",
        user_phone: userData?.["Numero di telefono"] || "Nessuna info",
        user_degree: userData?.["Titolo di studio"] || "Nessuna info",
        user_degree_score: userData?.Voto || "Nessuna info",
        user_city: userData?.["Città di residenza"] || "Nessuna info",
        user_age: userData?.Età || "Nessuna info",
        user_company_choice: userData?.Azienda || "Nessuna info",
        user_university: userData?.Università || "Nessuna info",
        user_faculty: userData?.["Facoltà (specificare)"] || "Nessuna info",
      };

      await startSession({
        agentId: process.env.REACT_APP_HUMANGEST_AGENT_ID, 
        timeout: 60000,
        dynamicVariables: dynamicVars,
      });
      console.log('Sessione avviata con agente pubblico');
      conversationStartedRef.current = true;
    } catch (error) {
      console.error("Errore nell'avvio della conversazione:", error);
    }
  };


  const evaluateConversation = async () => {
    
    try {
      // Prepara i dati per la richiesta OpenAI
      const conversationText = transcriptionRef.current.map(msg => 
        `${msg.sender === 'user' ? 'Candidato' : 'Intervistatore'}: ${msg.content}`
      ).join('\n\n');

      console.log("Conversation text:", conversationText);
      
      // Prepara i dati del candidato in formato leggibile
      const candidateInfo = `
        Nome: ${userData?.Nome || 'Non specificato'}
        Cognome: ${userData?.Cognome || 'Non specificato'}
        Email: ${email || 'Non specificato'}
        Telefono: ${userData?.Telefono || 'Non specificato'}
        Laurea: ${userData?.Laurea || 'Non specificato'}
        Voto: ${userData?.Voto || 'Non specificato'}
        Città: ${userData?.["Città di residenza"] || 'Non specificato'}
        Età: ${userData?.Età || 'Non specificato'}
        Azienda scelta: ${userData?.["Azienda Scelta per il colloquio"] || 'Non specificato'}
      `;
      
      // Prompt per OpenAI
      const prompt = `
        Sei un esperto valutatore di colloqui di lavoro con oltre 20 anni di esperienza in HR.
        Informazioni sul candidato:
        ${candidateInfo}
        Trascrizione del colloquio:
        ${conversationText}
        Analizza il colloquio in modo sistematico:
        1. COMPETENZE TECNICHE (0-20 punti)
          - Valuta la profondità e rilevanza delle conoscenze tecniche specifiche per il ruolo
          - Considera l'esperienza pratica dimostrata attraverso esempi concreti
          - Valuta la capacità di articolare concetti tecnici in modo comprensibile
        2. COMUNICAZIONE (0-20 punti)
          - Chiarezza e struttura logica delle risposte
          - Capacità di sintesi e pertinenza rispetto alle domande
          - Linguaggio professionale e appropriato al contesto aziendale
        3. ATTITUDINE E MOTIVAZIONE (0-20 punti)
          - Entusiasmo genuino per il ruolo e l'azienda
          - Allineamento tra valori personali e cultura aziendale
          - Proattività e orientamento alla soluzione dei problemi
        4. COERENZA E CREDIBILITÀ (0-20 punti)
          - Coerenza interna tra le diverse risposte
          - Allineamento tra esperienza dichiarata e competenze dimostrate
          - Autenticità complessiva del candidato
        5. FIT CULTURALE E POTENZIALE (0-20 punti)
          - Compatibilità con l'ambiente di lavoro e il team
          - Potenziale di crescita e adattabilità
          - Soft skills rilevanti per il ruolo specifico
        Per ogni criterio, assegna un punteggio specifico basato su evidenze concrete dalla trascrizione. Nella spiegazione, includi obbligatoriamente il punteggio assegnato per ogni categoria (es. ‘Competenze Tecniche: 15/20’).
        IMPORTANTE:
        - Se la conversazione è durata poco, quindi il candidato ha risposto solo a un paio di domande o meno, assegna un punteggio di 0 con la spiegazione appropriata
        - Valuta il candidato esclusivamente in base alle informazioni disponibili nella trascrizione
        - Evita bias personali e concentrati sui fatti oggettivi
        - Se un criterio non può essere valutato per mancanza di informazioni, assegnagli un punteggio neutro di 10
        Rispondi SOLO con un JSON nel seguente formato:
        {
          "score": [punteggio totale da 0 a 100],
          "explanation": "[Dettagliata valutazione che include esplicitamente i punteggi per ogni categoria (Competenze Tecniche: X/20, Comunicazione: X/20, ecc.) e giustificazioni basate su esempi specifici dalla trascrizione]"
        }
      `;
      
      // Chiamata a OpenAI
      const response = await axios.post('https://api.openai.com/v1/chat/completions', {
        model: "gpt-4o",
        messages: [
          { role: "system", content: "Sei un assistente esperto in valutazione di colloqui di lavoro." },
          { role: "user", content: prompt }
        ],
        temperature: 0.7,
        max_tokens: 1500
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`
        }
      });
      
      // Estrai il risultato
      const content = response.data.choices[0].message.content;
      console.log("Content:", content);
      let result;
      
      try {
        const cleanContent = content
        .replace(/^```json\n/, '')  // Rimuove ```json dall'inizio
        .replace(/\n```$/, '')      // Rimuove ``` dalla fine
        .trim();  
        // Cerca di estrarre il JSON dalla risposta
        result = JSON.parse(cleanContent);
        console.log("Parsificato:", result);
      } catch (e) {
        console.log("Errore nel parsing JSON:", e);
      
        // Fallback: estrazione manuale
        const scoreMatch = content.match(/["']score["']\s*:\s*(\d+)/);
        const explanationMatch = content.match(/["']explanation["']\s*:\s*["']([^"']+)["']/);
        
        result = {
          score: scoreMatch ? parseInt(scoreMatch[1]) : 50,
          explanation: explanationMatch ? 
            explanationMatch[1] : 
            "Impossibile estrarre la spiegazione"
        };
      }
      
      console.log("Valutazione OpenAI:", result);
      return result;
      
    } catch (error) {
      console.error("Errore nella valutazione con OpenAI:", error);
      return { score: 0, explanation: "Errore nella valutazione" };
    }
  };
  
  // Funzione per aggiornare il foglio di calcolo
  const updateSheetBest = async (score) => {
    console.log("Aggiorno sheet best")
    if (!email || !conversationIdRef.current) {
        console.log("NOn c'è email o conversationId:", email, conversationIdRef.current);
        return;
    };

    const conversationText = transcriptionRef.current.map(msg => 
      `${msg.sender === 'user' ? 'Candidato' : 'Intervistatore'}: ${msg.content}`
    ).join('\n\n');
    
    try {
      // Prepara i dati per l'aggiornamento
      const updateData = {
        "ID conversazione": conversationIdRef.current,
        "Score": score.score,
        "Valutazione": score.explanation,
        "Trascrizione": conversationText,
      };
      
      console.log("Aggiornamento dati:", updateData);
      
      // Chiamata API per aggiornare il foglio
      const response = await axios.patch(
        `https://api.sheetbest.com/sheets/ea03667d-aba0-4d57-b4a3-b325c66c5b3a/Email/${email}`,
        updateData,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      
      console.log("Aggiornamento SheetBest completato:", response.data);
      return response.data;
      
    } catch (error) {
      console.error("Errore nell'aggiornamento del foglio:", error);
      return null;
    }
  };

  // Termina la conversazione e imposta il riferimento a false
  const handleEndConversation = async () => {
    try {
      console.log("Termino la conversazione:", conversationIdRef.current)
      await endSession();
      conversationStartedRef.current = false;
      const evaluationResult = await evaluateConversation();
      console.log("Evaluation result:", evaluationResult);

      /*let s3AudioUrl = null;
      if (conversationIdRef.current) {
        console.log("Avvio caricamento audio su S3...");
        s3AudioUrl = await downloadAndUploadAudio(conversationIdRef.current);
      }*/

      if (evaluationResult) {
        // Aggiorna il foglio con i risultati
        console.log("Eseguo sheet best")
        await updateSheetBest(evaluationResult);
      }

    } catch (error) {
      console.error("Errore nella terminazione della conversazione:", error);
    }
  };

  const handleEndConversationAuto = async () => {
    try {
      console.log("Termino la conversazione")
      await endSession();
      console.log("Transcription:", transcription);
      conversationStartedRef.current = false;
      const evaluationResult = await evaluateConversation();
      console.log("Evaluation result:", evaluationResult);

      /*let s3AudioUrl = null;
      if (conversationIdRef.current) {
        console.log("Avvio caricamento audio su S3...");
        s3AudioUrl = await downloadAndUploadAudio(conversationIdRef.current);
      }*/

      if (evaluationResult) {
        // Aggiorna il foglio con i risultati
        console.log("Eseguo sheet best")
        await updateSheetBest(evaluationResult);
      }

    } catch (error) {
      console.error("Errore nella terminazione della conversazione:", error);
    }
  };

  const handleVolumeChange = async (e) => {
    const newVolume = parseFloat(e.target.value);
    setVolume(newVolume);
    await setConversationVolume({ volume: newVolume });
  };

  const handlePrivacyAccept = () => {
    setPrivacyAccepted(true);
  };

  return (
    <div className="elevenlabs-container container-employerland">
      {loading ? (
        <div>Caricamento...</div>
      ): 
        <div className="elevenlabs-container_">
          <img
            src={logo}
            alt="logo"
            className="logo logo-employerland"
            //onClick={() => window.open('https://www.deepagent.app/', '_blank')}
            style={{ cursor: 'pointer' }}
          />
        
            <div className="conversation-interface conversation-interface-employerland">
              <h2 className="title">Digital Talent Fair</h2>
              <p className='description'>Ti presentiamo Giulia la nostra assistente virtuale! <br />
              Fai il tuo colloquio con lei per entrare negli assessment di selezione con le aziende della Digital Talent Fair</p>

             {/* <p className="status">
                Stato connessione: <span>{status}</span>
              </p>} */}

              {isSpeaking && (
                <div className="audio-wave">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              )}

             
          {/* Popup video con URL dinamico basato su agentName */}
          {!privacyAccepted ? (
              <div className="privacy-overlay">
                <div className="privacy-content">
                  <h3>Informativa sulla Privacy</h3>
                  <p>
                  Utilizzando questo servizio per partecipare alle selezioni della Digital Talent Fair, accetti che i tuoi dati audio vengano elaborati per fornirti un’esperienza interattiva. Le tue conversazioni potrebbero essere registrate per migliorare la qualità del servizio.
                  </p>
                  <button 
                    className="privacy-accept-button" 
                    onClick={handlePrivacyAccept}
                  >
                    Accetto
                  </button>
                </div>
              </div>
          ) : (
           conversationDone ? (
              <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', marginTop: '40px'}}>
                <h2>Colloquio terminato</h2>
                <p>Grazie per aver partecipato al colloquio! <br />Ti faremo sapere il risultato il prima possibile</p>
              </div>
            ) : (
              <div className="modal-content modal-content-video">
                <video id="modalVideo" className='modalVideo-employerland' autoPlay loop muted playsInline>
                  <source src={videoSrc} type="video/mp4" />
                </video>
                
                <div className="label-video button-group">
                  <button className="start-button" id="playVega" onClick={handleStartConversation}>
                    <svg className="dynamic-fill dynamic-fill-employerland" width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="40" cy="40" r="38.5" stroke="white" strokeWidth="3" />
                      <path
                        d="M50.1405 59C49.9504 59 49.7604 58.9916 49.5619 58.9831C47.2225 58.8227 44.883 58.1344 41.9651 56.7494C36.809 54.2286 32.3159 50.7113 28.5955 46.2862C25.6227 42.7309 23.4479 39.0996 22.1346 35.4894C21.4801 33.6864 20.8382 31.5287 21.0367 29.143C21.1042 27.6398 21.7461 26.2549 22.8905 25.1866L25.7916 22.2815C27.4934 20.5799 29.8244 20.5714 31.5895 22.2646C32.1343 22.7671 32.6664 23.316 33.1815 23.8438C33.4391 24.1056 33.6967 24.3716 33.9628 24.6377L36.26 26.9347C38.0209 28.7714 38.0209 31.0305 36.2769 32.8503C35.7701 33.357 35.2761 33.8342 34.7862 34.3113C34.3682 34.7167 33.9501 35.122 33.5363 35.5358C34.0346 36.659 34.7651 37.7822 35.8757 39.1376C38.1983 41.9624 40.4448 44.0018 42.9448 45.5515L42.9997 45.5853C43.3121 45.8048 43.6964 45.9948 44.1018 46.1975C44.2116 46.2524 44.3256 46.3073 44.4354 46.3664L47.1549 43.6472C47.9953 42.8069 49.0003 42.3635 50.0645 42.3635C51.1286 42.3635 52.1337 42.8069 52.974 43.6472L57.6825 48.3552C59.4392 50.1117 59.4392 52.4721 57.6825 54.2286C57.3742 54.5369 57.0617 54.8409 56.7577 55.1407C56.1454 55.7403 55.5668 56.3061 55.0094 56.9014C53.7975 58.2864 52.1548 59 50.1405 59Z"
                        fill="white"
                      />
                    </svg>
                  </button>
                  <button className="end-button" id="stopVega" onClick={handleEndConversation}>
                    <svg className="dynamic-fill dynamic-fill-employerland" width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="40" cy="40" r="38.5" stroke="white" strokeWidth="3" />
                      <path
                        d="M19.3946 33.7354C19.529 33.601 19.6693 33.4726 19.8157 33.3382C21.5834 31.7974 23.7243 30.6299 26.7669 29.5459C32.1953 27.6824 37.8595 26.9924 43.6192 27.4908C48.2353 27.9027 52.3409 28.9326 55.8223 30.5567C57.56 31.3688 59.5396 32.4407 61.0862 34.2679C62.1014 35.3786 62.6268 36.8118 62.573 38.3764L62.5758 42.482C62.5757 44.8886 60.9334 46.5428 58.4879 46.5937C57.7475 46.6236 56.9831 46.6117 56.2456 46.6028C55.8783 46.5998 55.5081 46.5938 55.1318 46.5938L51.8832 46.594C49.3393 46.5404 47.7419 44.943 47.6883 42.4229C47.6883 41.7063 47.7003 41.0196 47.7093 40.3358C47.7183 39.7536 47.7272 39.1713 47.7273 38.5861C46.5807 38.1442 45.2699 37.8666 43.5262 37.6935C39.8864 37.3384 36.8558 37.4848 33.9923 38.1568L33.9296 38.1717C33.5534 38.2374 33.1473 38.3748 32.7173 38.5181C32.6009 38.5569 32.4814 38.5987 32.362 38.6346L32.3618 42.4804C32.3618 43.6687 31.9646 44.6929 31.2121 45.4454C30.4597 46.1979 29.4355 46.595 28.2471 46.5951L21.5887 46.5954C19.1044 46.5955 17.4354 44.9265 17.4354 42.4422Z"
                        fill="white"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            )
          )}
          </div>

        </div>
      }
    </div>
  );
};

export default  HumangestPage;